import React from 'react'
import { FLEXIBLE_DURATION_RANGE } from 'constants/search'
import Heading from 'components/Luxkit/Typography/Heading'
import styled from 'styled-components'
import DurationPicker, { DurationOption } from './DurationPicker'
import MonthPicker from './MonthPicker'
import { rem } from 'polished'

const Wrapper = styled.div`
  text-align: center;
`

const StyledMonthPicker = styled(MonthPicker)`
  margin-top: ${rem(16)};
`

const StyledDurationPicker = styled(DurationPicker)`
  margin-top: ${rem(16)};
`

const DurationSelection = styled.div`
  margin-top: ${rem(24)};
`

const MonthSelection = styled.div`
  margin-top: ${rem(16)};
  margin-bottom: ${rem(24)};
`

interface Props {
  onDurationChange?: (duration: FLEXIBLE_DURATION_RANGE) => void;
  onMonthChange?: (monthOptions: string) => void;
  onDatesChange?: () => void;
  previouslySelectedDuration?: FLEXIBLE_DURATION_RANGE;
  previouslySelectedMonths?: string;
  durationOptionsCustom?: DurationOption[];
  showYearSelector?: boolean;
}

function FlexibleDatePicker(props: Props) {
  const {
    onDurationChange,
    onMonthChange,
    previouslySelectedDuration,
    previouslySelectedMonths,
    durationOptionsCustom,
    showYearSelector,
  } = props
  return (
    <Wrapper>
      <DurationSelection>
        <Heading variant="heading6">How long?</Heading>
        <StyledDurationPicker
          durationOptionsCustom={durationOptionsCustom}
          previouslySelectedDuration={previouslySelectedDuration}
          onDurationChange={onDurationChange}
        />
      </DurationSelection>
      <MonthSelection>
        <Heading variant="heading6">When?</Heading>
        <StyledMonthPicker
          previouslySelectedMonths={previouslySelectedMonths}
          onMonthChange={onMonthChange}
          showYearSelector={showYearSelector}
        />
      </MonthSelection>
    </Wrapper>
  )
}

export default FlexibleDatePicker
